module.exports = __webpack_public_path__ + "static/img/cont215.a641139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont215.jpg
// module id = H/0B
// module chunks = 0